import { render, staticRenderFns } from "./robotManager.vue?vue&type=template&id=65027f8e&"
import script from "./robotManager.vue?vue&type=script&lang=js&"
export * from "./robotManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports